import { FieldType } from '@wix/wix-data-schema-types'
import type { DefaultField } from '../types'

export const DEFAULT_COLLECTION_FIELDS: Record<string, DefaultField> = {
  IMAGE: {
    fieldKey: 'image',
    displayName: 'Image',
    type: FieldType.image,
  },
  DESCRIPTION: {
    fieldKey: 'subtitle',
    displayName: 'Subtitle',
    type: FieldType.text,
  },
  TITLE: {
    fieldKey: 'title',
    displayName: 'Title',
    type: FieldType.text,
  },
  LONG_DESCRIPTION: {
    fieldKey: 'itemPageText',
    displayName: 'Item Page Text',
    type: FieldType.text,
  },
  ALT_TEXT: {
    fieldKey: 'imageAltText',
    displayName: 'Image alt text',
    type: FieldType.text,
  },
}
